import {controlRutas,fallbackRoutes} from './configRoutes';
import { Auth } from 'aws-amplify';
import store from '@/store';

import * as ENV from '@/env-vars';

export default async (to, from, next) => {

	try{

		let currentCredentials = await Auth.currentCredentials();
		let cUser = await Auth.currentAuthenticatedUser();
		// console.log('guard', cUser, currentCredentials)

		store.state.usuario.username = cUser.username;
		// evita el "auto-relogin"
		if( autoAccess( to.meta ) )
			next({ name: fallbackRoutes['principal'] });
		else{

			let puedeAcceder = tienePermiso(to.meta, store.state.usuario.permisos);
			let esRepresentanteLegal = store.state.usuario.esRepresentante;

			if( puedeAcceder || esRepresentanteLegal ){

				next();
			}else{

				// if( from.name !== to.name )
					next({ name: fallbackRoutes['principal'] });
			}
		}

	}catch(err){
		console.log('err', err);
		// en caso de que el destino SI REQUIERA de autentificacion, pero no está
		// autentificado, este será redireccionado al login "HARD REFRESH"
		if( to.meta.requiresAuth != false ){
			
			window.location.replace('/');
		}else{
			// de lo contrario se le permite el acceso
			next();
		}
	}
};

function tienePermiso( metaData, permisos ){

	let tiene = false;
	for( let permiso of permisos ){


		if( metaData.permiso === permiso || !metaData.permiso )
			return true;
	}
	return metaData.permiso === true;
}

// verifica si la ruta requiere o no ser redireccionada
// en cao de estar logeado
let autoAccess = function( routeMeta ){

	if( routeMeta.requiresAuth == false ){
		return true;
	}else{
		return false;
	}
}

function printOnConsole(...args){
	if( ENV.CAN_DEBBUG && window.DEBBUG_MODE === true ){
		console.log( ...args )
	}
}
